import axios from "axios";
export const BASE_URL1 = process.env.NEXT_PUBLIC_API_URL;
export const BASE_URL2 = process.env.NEXT_PUBLIC_WEB_URL;
export const BASE_URL3 = process.env.NEXT_PUBLIC_BLOG;
export const clientServer = axios.create({
  baseURL: BASE_URL1,
});
export const clientServerWeb = axios.create({
  baseURL: BASE_URL2,
});

export const clientServerBlog = axios.create({
  baseURL: BASE_URL3,
});
